export default __webpack_public_path__ + "static/card-sub-image-2-4ce22b4d46a6ee9c52b98fe0ecba9dc9.svg";